import req from "../methods/req"

//登录
export const getLoginInfo = function (data) {
    return req({
        url: '/manage/login/index',
        ...data
    })
}

// 可选分组
export const getGroupCate = function (data) {
    return req({
        url: '/manage/group/getGroupCate',
        ...data
    })
}

// 修改图片分组
export const editFile = function (data) {
    return req({
        url: '/manage/group/editFile',
        ...data
    })
}

// 新增
export const AddGroup = function (data) {
    return req({
        url: '/manage/group/add',
        ...data
    })
}

// oss
export const ossFile = function (data) {
    return req({
        url: '/manage/upload/ossFile',
        ...data
    })
}

//上传图片
export const uploadFile = function (data) {
    return req({
        url: '/manage/upload/file',
        ...data,
        mode: 'upload'
    })
}

//文件选择器
export const imageList = function (data) {
    return req({
        url: '/manage/upload/image',
        ...data,
    })
}
// 上传图片base64图片
export const uploadBaseImage = function (data) {
    return req({
        url: '/manage/upload/uploadBaseImage',
        ...data
    })
}
//获取可选平台
export const platformSelect = function (data) {
    return req({
        url: '/manage/choice/platform',
        ...data
    })
}

//获取可选客户
export const customerSelect = function (data) {
    return req({
        url: '/manage/choice/customer',
        ...data
    })
}

//获取可选类型
export const typeSelect = function (data) {
    return req({
        url: '/manage/choice/type',
        ...data
    })
}

//获取资源文件
export const resourceList = function (data) {
    return req({
        url: '/manage/choice/resource',
        ...data
    })
}

//获取可选渠道
export const channelList = function (data) {
    return req({
        url: '/manage/choice/channel',
        ...data
    })
}

//获取分类
export const categoryList = function (data) {
    return req({
        url: '/manage/choice/category',
        ...data
    })
}

//获取可选项目
export const projectList = function (data) {
    return req({
        url: '/manage/choice/project',
        ...data
    })
}

//获取可选小程序
export const wxList = function (data) {
    return req({
        url: '/manage/choice/wxList',
        ...data
    })
}

//获取树形商品分类列表
export const getTreeList = function (data) {
    return req({
        url: '/manage/goods_cate/getTreeList',
        ...data
    })
}